define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    exports.DamageStatus = void 0;
    var DamageStatus;
    (function (DamageStatus) {
        DamageStatus["Approved"] = "Approved";
        DamageStatus["Declined"] = "declined";
        DamageStatus["Reported"] = "Reported";
        DamageStatus["Solved"] = "Solved";
    })(DamageStatus = exports.DamageStatus || (exports.DamageStatus = {}));
});
//# sourceMappingURL=DamageStatus.js.map